// "Today" must be the USER'S LOCAL day, not UTC.
//
// `new Date().toISOString()` is UTC, so anything logged late in the evening (e.g. 10pm
// in a UTC-negative zone) rolls into the NEXT UTC day. That made last night's entries
// show up under "today" on the Log page and the daily checklist look pre-filled on a
// fresh morning. Build YYYY-MM-DD from the local calendar fields so the app's notion of
// "today" matches the wall clock the user is reading.
export const localToday = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
